import { display, fontSize, fontWeight, textAlign } from "@mui/system";

export const getStyles = (isRtl) => ({
  contact: {
    padding: '40px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    direction: isRtl ? 'rtl' : 'ltr',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  headerTitle: {
    fontSize: '2.5rem',
    color: 'rgb(154,74,32)',
    marginBottom: '20px',
  },
  contactInfoSection: {
    backgroundColor: '#fff',
    padding: '40px 20px',
    borderRadius: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  contactGrid: {
    display: 'flex',
    // gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '30px',
    justifyContent: 'start',
    flexDirection: 'column' 
},
  contactCard: {
    backgroundColor: '#f8f9fa',
    padding: '25px',
    borderRadius: '8px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
    },
    
  },
  contactCardH3: {
    fontSize: '1.25rem',
    color: '#333',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'start'
  },
  contactCardP: {
    color: '#666',
    marginBottom: '15px',
    lineHeight: '1.6',
    textAlign: 'start',
    fontSize: '18px',
    fontWeight: 500
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  contactCardPhone: {
    color: '#666',
    marginBottom: '5px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 500,
    fontSize: '18px'
  },
  contactLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  contactLinksA: {
    color: 'rgb(154,74,32)',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': {
      color: '#7c3a19',
    },
  },
  mapLink: {
    color: 'rgb(154,74,32)',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '8px 16px',
    backgroundColor: '#fff',
    borderRadius: '4px',
    border: '1px solid rgb(154,74,32)',
    fontSize: '0.9rem',
    width: '100%',
    '&:hover': {
      backgroundColor: 'rgb(154,74,32)',
      color: '#fff',
    },
  },
  icon: {
    fontSize: '20px',
  },
  mapImageContainer: {
    position: 'relative',
    width: '100%',
    borderRadius: '8px',
    overflow: 'hidden',
    marginBottom: '12px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      '& > a > div': {
        opacity: 1,
      },
    },
  },
  mapImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    transition: 'transform 0.3s ease',
  },
  mapOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  mapOverlayIcon: {
    color: '#fff',
    fontSize: '32px',
    marginBottom: '8px',
  },
  mapOverlayText: {
    color: '#fff',
    fontSize: '1rem',
    fontWeight: '500',
  },
}); 